import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import {
  AMENITIES_CREATE,
  AMENITIES_EDIT,
  AMENITIES_FILTER_STATUS_SUBMENU,
  AMENITIES_VIEW,
} from '../../../../../constants/AmenityConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_AMENITIES,
} from '../../../../../constants/RoleConsts';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  activateAmenityDetail,
  createDataSortMapping,
  deactivateAmenityDetail,
  deleteAmenityDetail,
} from '../../../../../utils/PropertyAPIUtils';
import {
  allAmenitiesSelector,
  allAmenityCategoriesSelector,
  fetchAllAmenities,
  setAllAmenities,
} from '../../../../property/propertySlice';
import './Amenities-List.scss';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  isDragDisabled,
  selectedCheckList,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const AmenitiesList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const originalAmenities = useSelector(allAmenitiesSelector);
  const originalCategories = useSelector(allAmenityCategoriesSelector);
  const dispatch = useDispatch();
  const [amenities, setAmenities] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const [filterMenu, setFilterMenu] = useState([]);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const amenityCategories = useSelector(allAmenityCategoriesSelector);
  const [searchText, setSearchText] = useState('');
  const [actionMenuList, setActionMenuList] = useState([]);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const [dragEnabled, setDragEnabled] = useState(true);

  const getCheckedinitalAmenitiesList = amenities?.filter((amenity) => amenity?.isChecked);

  const listOfAmenityIds = getCheckedinitalAmenitiesList?.map((amenity) => amenity?.id);

  const selectedInitialAmenitiesLength = getCheckedinitalAmenitiesList?.length;
  const dragDisabled = !dragEnabled || amenities?.length <= 1;

  const selectedAmenitiesLength = amenities?.filter((amenity) => amenity?.isChecked).length;

  useEffect(() => {
    if (originalCategories.length && originalAmenities.length) {
      // assigning data set to local list while keeping an orginal data set for filtering
      const amenitiesList = originalAmenities.map((obj) => {
        const isChecked = amenities.some((amenities) => {
          return amenities.id === obj.id && amenities.isChecked;
        });
        const catObj = originalCategories.find((c) => c.id === obj.categoryId);
        const returnObj = {
          ...obj,
          category: catObj ? catObj.name : '',
          isChecked: false,
        };
        return returnObj;
      });
      setAmenities(amenitiesList);
      setFilteredBaseList(amenitiesList);
    }
  }, [originalAmenities, originalCategories]);

  useEffect(() => {
    updateSelectedModule(amenities, setActionMenuList, setIsAllSelected);
  }, [amenities]);

  const resetFilterDataList = () => {
    const updatedFilterMenu = [];
    if (originalCategories.length) {
      const filterMenuCats = originalCategories.map((obj) => {
        return { id: obj.id, name: obj.name, selected: false };
      });

      updatedFilterMenu.push(
        {
          title: 'All',
          field: 'all',
          subMenu: [],
        },
        {
          title: 'Categories',
          field: 'categoryIds',
          subMenu: filterMenuCats,
        },
        {
          title: 'Status',
          field: 'status',
          subMenu: AMENITIES_FILTER_STATUS_SUBMENU,
        },
      );
      setFilterMenu(updatedFilterMenu);
    }
  };
  useEffect(() => {
    resetFilterDataList();
  }, [originalCategories]);

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      amenity: null,
    });
  };

  const handleCellMenuClick = (event, amenity) => {
    event.stopPropagation();
    if (selectedInitialAmenitiesLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: amenity.id,
        name: amenity.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        amenity: amenity,
      });
    }
  };

  const deleteAmenity = async (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed.',
      status: true,
      anchorEl: null,
    }));
  };

  const onDeleteAmenity = async (e) => {
    try {
      if (selectedHotel && selectedValue && selectedValue.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        await deleteAmenityDetail(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAmenities(selectedHotel));
        notificationManager('success', 'Hotel Compendium deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Hotel Compendium');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const onViewDetails = (pack, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(AMENITIES_VIEW, true, pack);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.amenity) {
      onViewToggle(AMENITIES_VIEW, true, selectedValue.amenity);
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  useEffect(() => {
    setSearchText('');
    setAmenities((prevList) => {
      return originalAmenities?.map((amenity) => {
        const isChecked = selectedCheckList(prevList, amenity.id);
        return {
          ...amenity,
          isChecked,
        };
      });
    });
  }, [originalAmenities]);

  useEffect(() => {
    if (loading || amenities?.length === 0) return;
    const totalItems = amenities?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [amenities?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(amenities, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setAmenities(updatedCheckedList);
  };

  const handleFilter = (filterItems, field) => {
    if (field === 'all') {
      setFilteredBaseList(originalAmenities);
      setAmenities(originalAmenities);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const filterIdWithFields = filterMenu
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);

      const filteredRecords = originalAmenities?.filter((amenity) => {
        const doesFilterSatisfy = filterIdWithFields?.map((filter) => {
          if (filter.field === 'categoryIds') {
            amenities.filter((amenity) => {
              return filterItems.some(
                (fItem) =>
                  field === 'categoryIds' && amenity[field].includes(fItem.id) && fItem.selected,
              );
            });
            return filter.id.some((item) => amenity[filter.field].includes(item));
          }

          if (filter.field === 'status') {
            const filterArray = filter.id.filter((ele) => {
              return (
                (ele === 'active' && amenity.isActive) || (ele === 'inactive' && !amenity.isActive)
              );
            });
            return filterArray.length ? true : false;
          }
        });
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setAmenities(filteredRecords);
    }
  };

  const onOpenDrawer = (event, type) => {
    if (selectedInitialAmenitiesLength) {
      setAmenities(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.amenity);
    handleClose();
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const getCategoryNames = (categoryIds) => {
    const displayName = categoryIds?.map(
      (itemData) => amenityCategories?.find((category) => category.id === itemData)?.name,
    );
    return displayName ? <span>{displayName?.join(', ')}</span> : '';
  };

  const onActiveDeactive = async (e, isActive) => {
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      e.preventDefault();
      isActive
        ? await deactivateAmenityDetail(selectedHotel, selectedValue.id, language)
        : await activateAmenityDetail(selectedHotel, selectedValue.id, language);
      dispatch(fetchAllAmenities(selectedHotel));
      notificationManager(
        'success',
        `Hotel Compendium ${isActive ? 'deactivated' : 'activated'} successfully`,
      );
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else
        notificationManager(
          'danger',
          `Failed to ${isActive ? 'deactivate' : 'activate'} Hotel Compendium`,
        );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  //bulk action changes
  const handleAction = (actionName) => {
    let selectedValue = amenities?.filter((amenity) => amenity?.isChecked);

    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleSelectAll = (event) => {
    let selectedAmenitiesList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedAmenitiesList = amenities?.map((amenity) => {
      return {
        ...amenity,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedAmenitiesList?.some((amenity) => amenity?.isActive);
    const isInactive = selectedAmenitiesList?.some((amenity) => !amenity.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setAmenities([...selectedAmenitiesList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedAmenitiesList?.some((amenity) => amenity?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = amenities?.findIndex((amenity) => amenity.id === id);
    if (!amenities[index]?.isChecked) {
      amenities[index] = { ...amenities[index], isChecked: true };
    } else {
      amenities[index].isChecked = !amenities[index]?.isChecked;
    }
    setAmenities([...amenities]);

    actionList = amenities
      ?.filter((amenity) => amenity?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = amenities?.filter((amenity) => amenity?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = amenities?.every((amenity) => amenity?.isChecked);
    setIsAllSelected(isAllSelected);
    setActionMenuList(actionListName);
  };

  const onApiCallConfirmationMessage = `${
    listOfAmenityIds.length > 1 ? 'Hotel Compendiums' : 'Hotel Compendium'
  } ${isActive ? 'activated' : 'deactivated'} successfully.`;

  const handleMultipleStatusChange = async (status) => {
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      setLoading(true);
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'AMENITY';
      await updateSelectedItemsStatus(
        listOfAmenityIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAmenities(selectedHotel));
      notificationManager('success', onApiCallConfirmationMessage);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Hotel Compendium was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setAmenities(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      setLoading(true);
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'AMENITY';
      await deleteSelectedItems(
        listOfAmenityIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAmenities(selectedHotel));
      notificationManager('success', 'Hotel Compendium deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Hotel Compendium',
      );
    }
    setIsAllSelected(false);
    setAmenities(ResetFilterList);
    setActionMenuList([]);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteAmenity}
          onDeleteCancel={onDeleteCancel}
        />
      )}

      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedInitialAmenitiesLength} ${
            selectedInitialAmenitiesLength > 1 ? 'Hotel Compendiums' : 'Hotel Compendium'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedInitialAmenitiesLength}  ${
            selectedInitialAmenitiesLength > 1 ? 'Hotel Compendiums' : 'Hotel Compendium'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}

      <SearchBar
        type={AMENITIES_CREATE}
        buttonName='Add Hotel Compendium'
        onOpenDrawer={onOpenDrawer}
        setSearchText={handleSearchText}
        filterList={filterMenu}
        setFilterDataList={setFilterMenu}
        filteredRecoard={handleFilter}
        displayAddOrEdit={
          permissions[RBAC_TYPE_HOTEL_AMENITIES] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? 'show'
            : 'hide'
        }
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={amenities}
        setPlaceHolder={setAmenities}
        globalPlaceHolder={originalAmenities}
        setGlobalPlaceHolder={setAllAmenities}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Amenity'
        module='AMENITY'
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setDrag={setDragEnabled}
      />

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          amenities && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedAmenitiesLength}
                        totalLength={amenities?.length}
                        inputProps={{
                          'aria-label': 'select all Amenities',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-40'>Name</TableCell>
                    <TableCell className='w-30'>Category</TableCell>
                    <TableCell align='center'>Status</TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      amenities,
                      setAmenities,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? amenities.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : amenities
                        ).map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(item, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 2 }}>
                                      <DragIndicator className='res-menu-accordion-drag ' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={() => handleCheckboxChange(item?.id)}
                                    checked={item?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select Amenities ${item?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-40'>{item?.name}</TableCell>
                                <TableCell className='w-40'>
                                  {getCategoryNames(item?.categoryIds) || item?.category || ''}
                                </TableCell>
                                <TableCell className='text-center'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`pill d-flex justify-content-center align-items-center ${
                                        item.isActive
                                          ? 'pill-active'
                                          : 'pill-inactive theme-dark-green'
                                      }`}
                                    >
                                      <span className='ms-1'>
                                        {item.isActive ? 'Active' : 'Inactive'}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_AMENITIES] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, item);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => onActiveDeactive(e, item.isActive)}
                                    >
                                      {item.isActive ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, AMENITIES_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteAmenity(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={amenities.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}{' '}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default AmenitiesList;
